import { put, select, takeLatest } from 'redux-saga/effects';
import { App } from '@ps20-frontend/frontend-models';
import { safeSaga } from '@ps20-frontend/safe-saga';
import { Selbstbeteiligung } from '@ps20/bff-models';

import { IAppState } from '../appState';
import { RsVermieterActions } from '../rs-vermietung-actions.service';

export function* watchRechtsstreitigkeitenChangedSaga() {
  yield takeLatest(
    RsVermieterActions.ANZAHL_RECHTSSTREITIGKEITEN_CHANGED,
    safeSaga(updateProduktlinienStatus, App.RS_VERMIETUNG),
  );
}

export function* updateProduktlinienStatus() {
  const state: IAppState = yield select();
  const vorschaeden = state.rechtsstreitigkeiten.anzahl;

  if (shouldResetSelbstbeteilgungToDefault(vorschaeden, state)) {
    yield put(
      new RsVermieterActions().selbstbeteiligungChanged(Selbstbeteiligung.SELBSTBETEILIGUNG_0150),
    );
  }
}

function shouldResetSelbstbeteilgungToDefault(vorschaeden: number, state: IAppState) {
  return (
    vorschaeden > 0 &&
    state.vertragsoptionen.selbstbeteiligung === Selbstbeteiligung.SELBSTBETEILIGUNG_0000
  );
}
